import $ from 'jquery'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.swiper')

  if (!wrapper.length) {
    return
  }

  const offerSlider = new Swiper(wrapper[0], {
    slidesPerView: 2,
    spaceBetween: 0,
    resistanceRatio: 0,
    navigation: {
      nextEl: $block.find('.offers-block__nav--next')[0],
      prevEl: $block.find('.offers-block__nav--prev')[0],
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  })

  const offerSliderNumberOfSlides = offerSlider.slides.length;

    if(offerSlider.params.breakpoints[768].slidesPerView > offerSliderNumberOfSlides) {
      offerSlider.params.breakpoints[768].slidesPerView = offerSliderNumberOfSlides
    }
    if(offerSlider.params.breakpoints[992].slidesPerView > offerSliderNumberOfSlides) {
      offerSlider.params.breakpoints[992].slidesPerView = offerSliderNumberOfSlides
    }
    if(offerSlider.params.breakpoints[1200].slidesPerView > offerSliderNumberOfSlides) {
      offerSlider.params.breakpoints[1200].slidesPerView = offerSliderNumberOfSlides
    }

  offerSlider.currentBreakpoint = false;
  offerSlider.update();
}

$('.offers-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=smdt-offers', initializeBlock)
}
